import * as Sentry from '@sentry/react';

export const sentryFeedback = Sentry.feedbackIntegration({
    autoInject: false,
    buttonLabel: 'Report a Bug',
    submitButtonLabel: 'Send Report',
    formTitle: 'Report a Bug',
    showBranding: false,
    isEmailRequired: true,
});

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [sentryFeedback],
});
